import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardComponent } from './dashboard.component';

const routes: Routes = [
    {
        path: '',
        component: DashboardComponent,
        children: [
            {
                path: 'medical',
                loadChildren: () =>
                    import('./pages/medical').then(
                        ({ MedicalModule }) => MedicalModule,
                    ),
            },
            {
                path: 'management',
                loadChildren: () =>
                    import('./pages/management').then(
                        ({ ManagementModule }) => ManagementModule,
                    ),
            },
            {
                path: 'admin',
                loadChildren: () =>
                    import('./pages/admin').then(
                        ({ AdminModule }) => AdminModule,
                    ),
            },
            {
                path: 'accounting',
                loadChildren: () =>
                    import('./pages/accounting').then(
                        ({ AccountingModule }) => AccountingModule,
                    ),
            },
        ],
    },
    {
        path: 'unknown',
        loadChildren: () =>
            import('./pages/unknown-role').then(
                ({ UnknownRoleModule }) => UnknownRoleModule,
            ),
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class DashboardRoutingModule {}
